import PropTypes from "prop-types";
import React, { Component } from "react";
import "./Toggle.css";

export default class Toggle extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    window.rawData = this.props.selected
    const { selected, toggleSelected } = this.props;
    return (
      <div className="toggle-main">
        <div className="rawtext">Raw Data</div>
      <div className="toggle-container" onClick={toggleSelected}>
        <div className={`dialog-button ${selected ? "" : "disabled"}`}>
          {selected ? "" : ""}
        </div>
      </div>
      </div>
    );
  }
}

